module.exports = __webpack_public_path__ + "img/edit_outline.201e6431.svg";